import { AppThunk } from "reducers/types"

export const getNewCallHistoryCount = (): AppThunk<number> => {
  return (dispatch, getState) => {
    return getState().callHistory.newCallHistoryCount
  }
}
